import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-column">
            <Link to="/" className="footer-logo">
              <h2>ShofexBD</h2>
            </Link>
          </div>

          {/* Shop Links */}
          <div className="footer-column">
            <h3>Shop</h3>
            <div className="footer-links">
              <Link to="/products?category=outerwear">Outerwear</Link>
              <Link to="/products?category=longerwear">Longerwear</Link>
              <Link to="/products?category=bottom">Bottom</Link>
              <Link to="/products">All</Link>
            </div>
          </div>

          {/* Customer Links */}
          <div className="footer-column">
            <h3>Customer</h3>
            <div className="footer-links">
              <Link to="/partnership">Partnership</Link>
              <Link to="/selling">Selling</Link>
              <Link to="/providing">Providing</Link>
              <Link to="/affiliate">Affiliate</Link>
            </div>
          </div>

          {/* Connect Links */}
          <div className="footer-column">
            <h3>Connect</h3>
            <div className="footer-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>

          {/* Security Links */}
          <div className="footer-column">
            <h3>Security</h3>
            <div className="footer-links">
              <Link to="/cookies">Cookies</Link>
              <Link to="/payment">Payment</Link>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>Copyright {currentYear} Urbanmuse. All Rights Reserved.</p>
          </div>
          <div className="footer-legal">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
